import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
// iView 完整引入
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
import VueTreeList from "vue-tree-list";
// 自定义组件引入
import iComp from "@/components";
// 工具函数引入
import Utils from "@/utils";
// 用户登录session信息
import userSession from "@/utils/userSession";
// 自定义组件引入
import vComp from "@/views/components";
//引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入打印
import Print from 'vue-print-nb'
//引入条形码
import VueBarcode from 'vue-barcode';
Vue.component('barcode', VueBarcode);

import {Button,Tabbar,Icon,NavBar} from 'vant'
Vue.use(Button).use(Tabbar).use(Icon).use(NavBar);

import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

import VueQrcode from 'vue-qrcode'
Vue.use(VueQrcode)

// Mock 数据引入
//import config from "@/config";

// 调用 `iView`
Vue.use(ViewUI);
// 调用 `iComp`
Vue.use(iComp);
// 调用 `vComp`
Vue.use(vComp);
// 调用VXETable
Vue.use(VXETable);
//调用tree
Vue.use(VueTreeList);
//调用element-ui
Vue.use(ElementUI);
Vue.use(Print);

Object.defineProperty(Vue.prototype, "$Utils", {
  value: Utils
});

Object.defineProperty(Vue.prototype, "$userSession", {
  value: userSession
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
